import Request from "./handler.js";

export const getSEO = (data) => {
    data.method = 'seo';
    const result = Request(data, 'post');
    return result;
}

export const getPostsSEO = (data) => {
    data.method = 'posts_seo';
    const result = Request(data, 'post');
    return result;
}

export const getSurveysSEO = (data) => {
    data.method = 'surveys_seo';
    const result = Request(data, 'post');
    return result;
}